export default __webpack_public_path__ + "static/media/jupyter-link.fc436ba8.svg";